
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

interface ProtectedRouteProps {
  redirectPath?: string;
}

const ProtectedRoute = ({ redirectPath = "/admin/login" }: ProtectedRouteProps) => {
  const { user, isLoading, isAdmin } = useAuth();

  // While checking auth state, show loading spinner
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }

  // If not authenticated or not admin, redirect to login
  if (!user || !isAdmin) {
    return <Navigate to={redirectPath} replace />;
  }

  // If authenticated and admin, show the protected content
  return <Outlet />;
};

export default ProtectedRoute;
